import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.7/js/sparta-messaging-utility";
import spartaTemplates from "modules/login/ah-caw-cq-module/5.2.1/js/templates";
import "css!modules/login/ah-caw-cq-module/5.2.1/css/ah-caw-cq-module.scss.css";






export default class ahCawCqController {
  constructor(parentModule) {
    this.parentModule = parentModule;
    this._model = parentModule.model;
    this._view = parentModule.view;

    const self = this;
    this.bindThisConext(['_defineVars', '_bindEventHandlers', '_listen',
      '_subscribeEvents', '_initialize'],
        self, '');
  }

  bindThisConext(methods, context, suffix = 'Scoped') {
    const self = context;

    if (methods && $.isArray(methods) && methods.length > 0) {
      $(methods).each((index, method) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }

  _defineVars() {
    return this;
  }

  _bindEventHandlers() {
    return this;
  }

  _listen() {
    return this;
  }

  _getDefaultValue(originatingFrom){
    let requestValue = {};
    if(typeof originatingFrom !== 'undefined' && originatingFrom === 'OCA-GWIM'){
       requestValue =   { 
          "filterRules": [
          {
            "value": "TO_BE_FILLED",
            "name": "CLIENT"
          },
          {
            "value": "TO_BE_FILLED",
            "name": "SOURCE"
          },
          {       
              "value": "TO_BE_FILLED",
              "name": "FLOW"
          }
        ]
      }
    }else{
       requestValue = {
                        "stepUpToken": {
                              "stepUpType": "CQ"
                        },
                        "processRules": [
                          {
                            "name": "AuthenticationContext",
                            "value": "SIGNONCHLG"
                          }
                        ]
                    }
      } 
      return requestValue; 
  }

  _subscribeEvents() {
    const that = this;
    const main = this.parentModule;
    const controller = this.parentModule.controller;

      main.Events.sub(cawEventsMasterUtility.EVENTS.SECOND_FACTOR_CHALLENGE_INIT, (e) => {
        const widgetInfo = main.Store.getData('widgetConfigData');


        if(e.data){
          if(e.data.securityPreference && typeof(e.data.securityPreference) !== "object" ){
              let securityPref = e.data.securityPreference;
              main.userPref = securityPref.slice(0,1);
              main.devicePref = securityPref.slice(1,2);
              $('#ahPageTitleContainer').addClass('hidden');
          }
        }
        let inputJson = {};
        if(widgetInfo.originatingFrom === 'OCA-GWIM'){
            inputJson = that._getDefaultValue(widgetInfo.originatingFrom);
            inputJson.filterRules[0].value = widgetInfo.client;
            inputJson.filterRules[1].value = widgetInfo.source;
            inputJson.filterRules[2].value = widgetInfo.usecase;
        }else{
            inputJson = that._getDefaultValue("CAW-Site");
        }

        if(widgetInfo&&widgetInfo.domain){
                main.apiEndPoints = ahCawCommons.getEndPoints(main.endpoints, widgetInfo.domain);
        }

        let urlValue = main.apiEndPoints.requestChallengeQuestion;
        if(widgetInfo.originatingFrom === 'OCA-GWIM'){
            urlValue =  main.apiEndPoints.GWIMRequestCQ;
        }

        const ajaxOptions = {
            method: 'POST',
            data: JSON.stringify(inputJson),
            url: urlValue,
            crossDomain: true,
            cache: false,
            timeout: 60000,
            processData: false,
            xhrFields:{
              withCredentials:true
            },
            headers: {
              'content-type': 'application/json',
              clientAIT: '41339',
              accept: 'application/json',
              'cache-control': 'no-cache',
            },
            dataType:'json'
          }
        const initiateCall =  new ahCawTransportUtility();
        initiateCall._serviceCall(ajaxOptions,function(response){
              let data = response.responseData;

















              if(data.redirectResult){

                if(data.redirectResult.authResult ==='CQ_LOCKED'){
                    controller.emit({ context: 'cq-error-info', data :"You've exceeded the maximum number of attempts to answer your challenge questions and your account is locked. Proceed to sign-in."})
                }else{
                   controller.emit({context:'cq-other-error'})
                }
              }else{
                if (data.errorInfo && data.errorInfo[0] && data.errorInfo[0].code) {
                  controller.emit({ context: 'cq-error-redraw', data : data.errorInfo[0].code});
                }else{
                  if(widgetInfo && widgetInfo.originatingFrom === 'OCA-GWIM'){
                       controller.emit({ context: 'update-challenge-question-data', data: data});
                       controller.emit({ context: 'PAINT-GWIM_CQ-MODULE', data :e.data.inputData.oid});
                  }else{
                      controller.emit({context:'show-verify-info'});
                      controller.emit({ context: 'update-challenge-question-data', data: data});
                      if(e.data && e.data.inputData && e.data.inputData.oid){
                          controller.emit({ context: 'PAINT-CQ-MODULE', data :e.data.inputData.oid});
                      }
                  }
                }
              }
        },function(errorResponse){

          console.log(errorResponse);
        })
        main._debug('Initialize CQ widget with: ', e);
        main._debug(`CQ Module: ${JSON.stringify(e)}`);
        main.callbackTarget = e.data.successCallback;

    });
    return this;
  }

  _initialize() {
    this._defineVars()
        ._bindEventHandlers()
        ._subscribeEvents()
        ._listen();
  }
}
